import isIEbrowser from '../../../resources/scripts/helpers/is-IE';

class BrixLatestPosts {
  static init(...parameters) {
    return new BrixLatestPosts(...parameters);
  }

  constructor(container) {
    this.container = container;
    const IE = isIEbrowser();

    if (container) {
      this.poster = container.querySelectorAll('.image');

      if (this.poster && IE) {
        for (let i = 0; i < this.poster.length; i += 1) {
          window.objectFitPolyfill(this.poster[i]);
        }
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-latest-news', BrixLatestPosts.init);
}
